var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "254px",
  height: "35px",
  viewBox: "0 0 254 35",
  version: 1.1,
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "schmodel.studios")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Talent-signup-confirmation",
  transform: "translate(-596.000000, -765.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "shcmodel.studios",
  transform: "translate(596.000000, 765.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#FFFFFF",
  x: 0,
  y: 0,
  width: 254,
  height: 35,
  rx: 17.5
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(18.708333, 8.708333)",
  stroke: "#000000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 9.1666665,
  cy: 9.1666665,
  r: 4.01041659
}), /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 14.4718747,
  cy: 3.8729166,
  r: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 18.333333,
  height: 18.333333,
  rx: 4
})), /*#__PURE__*/React.createElement("text", {
  id: "Follow-@schmodel.stu",
  fontFamily: "OpenSans-Bold, Open Sans",
  fontSize: 14,
  fontWeight: "bold",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 48.1865234,
  y: 23
}, "Follow @schmodel.studios")))))));
export default __webpack_public_path__ + "static/media/schmodelstudiosbutton.65e36f2c.svg";
export { SvgComponent as ReactComponent };